import React from "react";
import { NavLink, useLocation } from "react-router-dom";
// Using BoxIcons to match the SideNav style
import { BiHomeAlt, BiTransfer, BiTrendingUp, BiCog } from "react-icons/bi";

export const BottomNav = () => {
  const { pathname } = useLocation();

  const navLinks = [
    {
      name: "home",
      label: "Home",
      icon: <BiHomeAlt size={24} />,
    },
    {
      name: "transaction",
      label: "Transact",
      icon: <BiTransfer size={24} />,
    },
    {
      name: "investment",
      label: "Invest",
      icon: <BiTrendingUp size={24} />,
    },
    {
      name: "setting",
      label: "Settings",
      icon: <BiCog size={24} />,
    },
  ];

  return (
    <div className="fixed bottom-6 left-0 right-0 z-50 flex justify-center px-4 pointer-events-none">
      {/* Container:
        - Floating (rounded-2xl)
        - Glass Effect (backdrop-blur-xl + bg-white/80)
        - Subtle Border (border-white/50)
        - Shadow for depth
      */}
      <nav className="pointer-events-auto w-full bg-white/70 backdrop-blur-xl border border-white/50 shadow-[0_10px_40px_-10px_rgba(0,0,0,0.1)] rounded-2xl flex items-center justify-between px-2 py-3 relative overflow-hidden">
        {/* Top Shine Highlight (The "Glam" detail) */}
        <div className="absolute top-0 inset-x-0 h-px bg-gradient-to-r from-transparent via-white to-transparent opacity-70"></div>

        {navLinks.map((link) => {
          // Check if this link is active
          const isActive = pathname.includes(`/dashboard/${link.name}`);

          return (
            <NavLink
              key={link.name}
              to={`/dashboard/${link.name}`}
              className="flex-1 relative group"
            >
              <div className="flex flex-col items-center justify-center gap-1 py-1">
                {/* Active Indicator: A soft blue glow behind the icon */}
                {isActive && (
                  <div className="absolute top-1/2 left-1/2 -translate-x-1/2 -translate-y-1/2 w-12 h-12 bg-blue-500/10 rounded-full blur-md -z-10 animate-pulse"></div>
                )}

                {/* Icon with Transition */}
                <div
                  className={`transition-all duration-300 ease-out ${
                    isActive
                      ? "text-blue-600 -translate-y-1 scale-110"
                      : "text-slate-400 group-hover:text-slate-600"
                  }`}
                >
                  {link.icon}
                </div>

                {/* Label: Only visible when active (or always visible depending on preference) */}
                {/* Here we keep it always visible but bold when active for better UX */}
                <span
                  className={`text-[10px] font-body tracking-wide transition-colors duration-300 ${
                    isActive
                      ? "font-bold text-blue-700"
                      : "font-medium text-slate-400"
                  }`}
                >
                  {link.label}
                </span>

                {/* Active Dot at the bottom */}
                <span
                  className={`absolute -bottom-2 w-1 h-1 bg-blue-600 rounded-full transition-all duration-300 ${
                    isActive
                      ? "opacity-100 -translate-y-2"
                      : "opacity-0 translate-y-0"
                  }`}
                ></span>
              </div>
            </NavLink>
          );
        })}
      </nav>
    </div>
  );
};
